import React from 'react';

export default function TimeDisplay({ value, type }) {
  return (
    <div className="flex relative">
      <p className="bg-primary-50 text-primary-900 w-6 h-6 rounded-md  justify-center flex items-center text-xs font-bold">
        {value}
      </p>
      <span className="absolute -bottom-4 right-0 left-0 text-primary-500 text-center text-tiny">
        {type}
      </span>
    </div>
  );
}
